import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var FormatIndentIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M7 1.911a1 1 0 01.993.884L8 2.91V20.96a1 1 0 01-1.993.117L6 20.959V2.911a1 1 0 011-1zM21.35 17c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zm0-4c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zm-19-3.47l2.215 1.83c.43.353.436.922 0 1.281l-2.215 1.83c-.746.615-1.35.333-1.35-.64V10.17c0-.969.604-1.256 1.35-.64zm19-.53c.39 0 .65.4.65 1s-.26 1-.65 1H9.65c-.39 0-.65-.4-.65-1s.26-1 .65-1zm0-4c.39 0 .65.4.65 1s-.26 1-.65 1H9.65C9.26 7 9 6.6 9 6s.26-1 .65-1z",
                        fillRule: "evenodd"
                    })
                })
            })
        ]
    });
};
FormatIndentIcon.isCarinaIcon = true;
export default FormatIndentIcon;
